/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import * as React from "react";
import RcDialog from "rc-dialog";
import classNames from "classnames";

import CloseOutlined from "../../resources/icons/close-dark.svg";

let mousePosition: { x: number; y: number } | undefined;
export const destroyFns: Array<() => void> = [];

const getClickPosition = (e: MouseEvent) => {
  mousePosition = {
    x: e.pageX,
    y: e.pageY,
  };
  setTimeout(() => {
    mousePosition = undefined;
  }, 100);
};

if (
  typeof window !== "undefined" &&
  window.document &&
  window.document.documentElement
) {
  window.document.addEventListener("click", getClickPosition);
}

type getContainerFunc = () => HTMLElement;

export interface IDialogProps {
  visible?: boolean;
  closable?: boolean;
  onCancel?: (e: Event) => void;
  afterClose?: () => void;
  centered?: boolean;
  width?: number;
  footer?: React.ReactNode;
  maskClosable?: boolean;
  forceRender?: boolean;
  destroyOnClose?: boolean;
  style?: React.CSSProperties;
  wrapClassName?: string;
  maskTransitionName?: string;
  transitionName?: string;
  className?: string;
  getContainer?: string | HTMLElement | getContainerFunc | false | null;
  zIndex?: number;
  bodyStyle?: React.CSSProperties;
  maskStyle?: React.CSSProperties;
  mask?: boolean;
  keyboard?: boolean;
  prefixCls?: string;
}

type IDialogInterface = React.FC<IDialogProps>;

const Dialog: IDialogInterface = ({
  visible,
  wrapClassName,
  onCancel,
  ...restProps
}) => {
  const onClose = (e: React.SyntheticEvent<Element, Event>) => {
    if (onCancel) {
      onCancel(e.nativeEvent);
    }
  };

  const closeIconToRender = (
    <span className="Dialog-close-x">
      <CloseOutlined />
    </span>
  );

  const wrapClassNameExtended = classNames("Dialog-centered", wrapClassName);

  React.useEffect(() => {
    if (visible) {
      document.documentElement.style.overflowY = "hidden";
    } else {
      document.documentElement.style.overflowY = "";
    }

    return () => {
      document.documentElement.style.overflowY = "";
    };
  }, [visible]);

  return (
    <RcDialog
      {...restProps}
      getContainer={() => document.getElementById("root") || document.body}
      prefixCls="Dialog"
      wrapClassName={wrapClassNameExtended}
      visible={visible}
      mousePosition={mousePosition}
      onClose={onClose}
      closeIcon={closeIconToRender}
    />
  );
};

Dialog.defaultProps = {
  transitionName: "zoom",
  maskTransitionName: "fade",
  visible: false,
};

export { Dialog };

export default Dialog;
